export default __webpack_public_path__ + "static/media/template29.e8a284f2.svg";